import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable, Subject, Observer } from 'rxjs';
import { CrudService } from '.';
import { IncidenciaUsuario, SaveIncidenciaHilo, SaveIncidenciaUsuario, SearchIncidenciaHiloItemDto, SearchIncidenciaUsuarioRequestDto, ViewHilosRequestDto } from '../model';
import { GenericResponse, GenericSearchResponse, CantidadNoLeidosUsuarioDto, UploadIncidenciaUsuarioAttachResponseDto } from '../model';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})

export class IncidenciaUsuarioService extends CrudService<IncidenciaUsuario, number, SaveIncidenciaUsuario, SearchIncidenciaUsuarioRequestDto> { 
  constructor(protected _http: HttpClient, private datePipe: DatePipe, protected sharedFunctions: SharedFunctions) {
    super(_http,'incidenciaUsuario', sharedFunctions);
  }

  public messageReadSubject: Subject<number> = new Subject<number>();

  viewHilos(value: ViewHilosRequestDto): Observable<GenericSearchResponse<SearchIncidenciaHiloItemDto>> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<GenericSearchResponse<SearchIncidenciaHiloItemDto>>(this._serviceUrl + '/view-hilos' + queryString, this.httpOptions);
  }

  getTotalUnread(): Observable<GenericResponse<CantidadNoLeidosUsuarioDto>> {
    return this._http.get<GenericResponse<CantidadNoLeidosUsuarioDto>>(this._serviceUrl + '/total-no-leidos', this.httpOptions);
  }

  exportMySearch(value: SearchIncidenciaUsuarioRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-search-self' + queryString, this.httpCsvOptions);
  }

  saveHilo(p: SaveIncidenciaHilo): Observable<GenericResponse<number[]>> {
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl + '/save-hilo', p, this.httpOptions);
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadIncidenciaUsuarioAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadIncidenciaUsuarioAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  markHiloAsRead(id: number): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/hilo/leido/'+id, null, this.httpOptions);
  }

  informMessageRead(messageId: number): void {
    this.messageReadSubject.next(messageId);
  }

  onMessageRead(): Observable<number> {
    return this.messageReadSubject;
  }
}